<template>
  <div class="ch HomeView">
    <my-header :menu-index="1" id="a1" />
    <div class="one">
      <!-- <img :src="fileServerUrl + 'assets/phamax/phamaxBg.jpg'" /> -->
      <!-- <transition-group
        name="animate__animated animate__fadeInUp"
        appear
        enter-active-class="animate__fadeInUp"
        leave-active-class="animate__fadeOutUp"
      >
        <div class="one-font" key="1">
          <div class="ty-display-col pha-top">
            <div class="ty-display">
              <span style="font-size: 0.4rem" class="ty-shuhei">PHARMA</span>
              <span style="font-size: 0.4rem" class="ty-shuhei ty-color"
                >X</span
              >
            </div>
            <span class="ty-lineheight ty-shuhei" style="font-size: 0.4rem">{{
              $t("home_title1")
            }}</span>
            <span class="ty-font ty-lineheight" style="font-size: 0.14rem">{{
              $t("home_title2")
            }}</span>
          </div>
          <div class="time-site">
            <div class="ty-display time-site-item1">
              <i
                class="el-icon-date ty-color"
                style="margin-right: 15px; font-size: 0.15rem"
              ></i>
              <span style="font-size: 0.13rem">{{ $t("home_title3") }}</span>
            </div>
            <div class="ty-display time-site-item2">
              <i
                class="el-icon-location-outline ty-color"
                style="font-size: 0.15rem; margin-right: 7px"
              ></i>
              <span style="font-size: 0.13rem">{{ $t("home_title4") }}</span>
            </div>
            <button class="once-join">
              {{ $t("home_title5") }}
            </button>
          </div>
        </div>
      </transition-group> -->
    </div>
    <div class="two">
      <div class="two2">
        <div class="two1" style="border: 0">
          <font style="display: flex">
            <animate-number from="0" to="10" duration="2000"></animate-number>
            <span class="ty-color">+</span>
          </font>
          <span class="two-span" style="color: #545454; font-size: 0.11rem">
            {{ $t("toll") }}
          </span>
        </div>
        <div class="two1">
          <font style="display: flex">
            <animate-number from="0" to="15" duration="2000"></animate-number>
            <b style="color: rgb(31, 163, 209)">+</b>
          </font>
          <span class="two-span" style="color: #545454; font-size: 0.11rem">
            {{ $t("too2")}}
          </span>
        </div>
        <div class="two1">
          <font style="display: flex">
            <animate-number from="0" to="80" duration="2000"></animate-number>
            <b style="color: rgb(31, 163, 209)">+</b>
          </font>
          <span class="two-span" style="color: #545454; font-size: 0.11rem">
            {{ $t("too3") }}
          </span
          >
        </div>
        <div class="two1">
          <font style="display: flex">
            <animate-number from="0" to="150" duration="2000"></animate-number>
            <b style="color: rgb(31, 163, 209)">+</b>
          </font>
          <span class="two-span" style="color: #545454; font-size: 0.11rem">
            {{ $t("too4") }}
          </span>
        </div>
      </div>
      <!-- <hr class="hr-dashed-fixed" /> -->
    </div>


    <div class="hyld">
      <div class="hyld-item1">
        <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
        "
      >
        <span class="title" style="width: 2rem">{{
          $t("meetIntroText")}}</span>
        <hr style="height: 0.5px; width: 80%" class="hr-dashed-fixed" />
      </div>


        <div class="hyld-item-wenzi ty-wenzi text">
          <p>
            {{ $t("intro2") }}
          </p>
          <div class="textCont">
            <div class="textCont01" style="width:46%">
              <p class="tit">{{$t('meet_intro_tit')}}</p>
              <div class="cont">
                <p>● {{$t('meet_intro_cont_1')}}</p>
                <p>● {{$t('meet_intro_cont_2')}}</p>
              </div>
            </div>
            <div class="textCont01" style="width:46%">
              <p class="tit">{{$t('meet_intro_tit2')}}</p>
              <div class="cont">
                <p>● {{$t('meet_intro_cont2_1')}}</p>
                <p>● {{$t('meet_intro_cont2_2')}}</p>
              </div>
            </div>

            <div class="textCont01" style="width:46%">
              <p class="tit">{{$t('meet_intro_tit3')}}</p>
              <div class="cont">
                <p>● {{$t('meet_intro_cont3_1')}}</p>
                <p>● {{$t('meet_intro_cont3_2')}}</p>
              </div>
            </div>
            <div class="textCont01" style="width:46%">
              <p class="tit">{{$t('meet_intro_tit4')}}</p>
              <div class="cont">
                <p>● {{$t('meet_intro_cont4_1')}}</p>
                <p>● {{$t('meet_intro_cont4_2')}}</p>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>


    <div
      class="conference-highlights"
      ref="huiyi"
      :class="{
        testhuiyi: true,
        testhuiyienter: aboutCoreShow,
        testhuiyileave: !aboutCoreShow,
      }"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
        "
      >
        <span class="title" style="width: 2rem">{{
          $t("conference_highlights")
        }}</span>
        <hr style="height: 0.5px;width:80%" class="hr-dashed-fixed" />
      </div>

      <div style="width:100%;text-align:center;margin-top:-20px;">
        <img style="width:100%;" :src="fileServerUrl + 'assets/phamax/pharmax-a3.jpg'" />
      </div>

      <div class="titSub">
       <span class="title num">01</span> {{$t('highlights_tit1')}}
      </div>
      <div class="textSubCont">
        <p><img :src="fileServerUrl + 'assets/phamax/phaIcon2.png'" style="width:0.3rem;margin-right:0.1rem" /></p>
        <p>{{$t('highlights_text1')}}</p>
      </div>

      <div class="titSub">
       <span class="title num">02</span> {{$t('highlights_tit2')}}
      </div>
      <div class="textSubCont">
        <p><img :src="fileServerUrl + 'assets/phamax/phaIcon3.png'" style="width:0.3rem;margin-right:0.1rem" /></p>
        <p>{{$t('highlights_text2')}}</p>
      </div>
      <div class="titSub">
       <span class="title num">03</span> {{$t('highlights_tit3')}}
      </div>
      <div class="textSubCont">
        <p><img :src="fileServerUrl + 'assets/phamax/phaIcon4.png'" style="width:0.3rem;margin-right:0.1rem" /></p>
        <p>{{$t('highlights_text3')}}</p>
      </div>
      <div class="titSub">
       <span class="title num">04</span> {{$t('highlights_tit4')}}
      </div>
      <div class="textSubCont">
        <p><img :src="fileServerUrl + 'assets/phamax/phaIcon5.png'" style="width:0.3rem;margin-right:0.1rem" /></p>
        <p>{{$t('highlights_text4')}}</p>

      </div>
      <div class="titSub">
       <span class="title num">05</span> {{$t('highlights_tit5')}}
      </div>

      <div class="textSubCont">
        <p><img :src="fileServerUrl + 'assets/phamax/phaIcon6.png'" style="width:0.3rem;margin-right:0.1rem" /></p>
        <p>{{$t('highlights_text5')}}</p>
      </div>




      <!-- 图片滚动 -->
      <!-- <div class="swiper_area">
        <el-carousel
          :interval="4000"
          type="card"
          height="400px"
          indicator-position="outside"
        >
          <el-carousel-item v-for="item in imgs" :key="item.id">
            <img :src="item.img" class="image" width="100%" height="100%" />
          </el-carousel-item>
        </el-carousel>
      </div> -->


      <!--  <div style="display: flex; margin: 60px 0">
        <div v-if="active == 0 || active > 2" class="group">
          <div @mouseenter="active = 1" @mouseleave="active = 0" class="item">
            <img :src="fileServerUrl + 'assets/phamax/hyld-01.jpg'" />
            <div class="hyld-tu-wz hyld-tu-wz-bg1">{{ $t("highlights1") }}</div>
          </div>
          <div @mouseenter="active = 2" @mouseleave="active = 0" class="item">
            <img :src="fileServerUrl + 'assets/phamax/hyld-02.jpg'" />
            <div class="hyld-tu-wz hyld-tu-wz-bg2">{{ $t("highlights4") }}</div>
          </div>
        </div>
        <div v-if="active == 1" @mouseleave="active = 0" class="group">
          <div class="full-bg"></div>
          <img
            class="full-img"
            :src="fileServerUrl + 'assets/phamax/hyld-1.png'"
          />
          <div class="full-text">
            <span>{{ $t("highlights1") }}</span>
          </div>
        </div>
        <div
          v-if="active == 2"
          @mouseleave="active = 0"
          class="group transition-box"
        >
          <div class="full-bg"></div>
          <img
            class="full-img"
            :src="fileServerUrl + 'assets/phamax/hyld-2.png'"
          />
          <div class="full-text">
            <span>{{ $t("highlights4") }}</span>
          </div>
        </div>

        <div v-if="active == 0 || active <= 2 || active > 4" class="group">
          <div @mouseenter="active = 3" @mouseleave="active = 0" class="item">
            <img :src="fileServerUrl + 'assets/phamax/hyld-03.jpg'" />
            <div class="hyld-tu-wz hyld-tu-wz-bg2">{{ $t("highlights2") }}</div>
          </div>
          <div @mouseenter="active = 4" @mouseleave="active = 0" class="item">
            <img :src="fileServerUrl + 'assets/phamax/hyld-05.jpg'" />
            <div class="hyld-tu-wz hyld-tu-wz-bg1">{{ $t("highlights5") }}</div>
          </div>
        </div>
        <div v-if="active == 3" @mouseleave="active = 0" class="group">
          <div class="full-bg"></div>
          <img
            class="full-img"
            :src="fileServerUrl + 'assets/phamax/hyld-3.png'"
          />
          <div class="full-text">
            <span>{{ $t("highlights2") }}</span>
          </div>
        </div>
        <div
          v-if="active == 4"
          @mouseleave="active = 0"
          class="group transition-box"
        >
          <div class="full-bg"></div>
          <img
            class="full-img"
            :src="fileServerUrl + 'assets/phamax/hyld-5.png'"
          />
          <div class="full-text">
            <span>{{ $t("highlights5") }}</span>
          </div>
        </div>

        <div v-if="active == 0 || active <= 4 || active > 6" class="group">
          <div @mouseenter="active = 5" @mouseleave="active = 0" class="item">
            <img :src="fileServerUrl + 'assets/phamax/hyld-04.jpg'" />
            <div class="hyld-tu-wz hyld-tu-wz-bg1">{{ $t("highlights3") }}</div>
          </div>
          <div @mouseenter="active = 6" @mouseleave="active = 0" class="item">
            <img :src="fileServerUrl + 'assets/phamax/hyld-06.jpg'" />
            <div class="hyld-tu-wz hyld-tu-wz-bg2">{{ $t("highlights6") }}</div>
          </div>
        </div>
        <div v-if="active == 5" @mouseleave="active = 0" class="group">
          <div class="full-bg"></div>
          <img
            class="full-img"
            :src="fileServerUrl + 'assets/phamax/hyld-4.png'"
          />
          <div class="full-text">
            <span>{{ $t("highlights3") }}</span>
          </div>
        </div>
        <div
          v-if="active == 6"
          @mouseleave="active = 0"
          class="group transition-box"
        >
          <div class="full-bg"></div>
          <img
            class="full-img"
            :src="fileServerUrl + 'assets/phamax/hyld-6.png'"
          />
          <div class="full-text">
            <span>{{ $t("highlights6") }}</span>
          </div>
        </div>
      </div> -->
    </div>

    <div
      class="yjjb"
      ref="yjjb"
      :class="{
        testhuiyi: true,
        testhuiyienter: yjjbShow,
        testhuiyileave: !yjjbShow,
      }"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
        "
      >
        <span class="title">
          {{ $t("guests_title1") }}
        </span>
        <hr style="height: 0.5px; width: 60%" class="hr-dashed-fixed" />
      </div>
      <!--            <div class="text">
                PharmaX与您一样非常关注医药行业发展趋势与实时动态，我们与行业影响者、创新者，一同洞察行业政策、趋势、热点、痛点及新兴技术，分享优秀案例研究、新项目、新技术和独特见解，助力制药、医疗器械、生物技术、诊断、医疗机构和制药零售企业英才拥抱未来医药。
            </div>-->
      <div class="yjjb-bottom">
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/208.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest1_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest1_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest1_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/207.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest2_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest2_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest2_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/203.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest3_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest3_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest3_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/214.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest4_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest4_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest4_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/209.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest5_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest5_2") }}<br />{{ $t("guest5_3") }}<br />
              <span style="font-weight: bold">{{ $t("guest5_4") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/204.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest6_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest6_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest6_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/202.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest7_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest7_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest7_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/206.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest8_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest8_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest8_3") }}</span>
            </div>
          </div>
        </div>

        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/218.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest9_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest9_2") }}<br />{{ $t("guest9_3") }}<br />
              <span style="font-weight: bold">{{ $t("guest9_4") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/jiabin/custo-22.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest10_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest10_2") }}<br />
              <span style="font-weight: bold"
                >{{ $t("guest10_3") }}<br />{{ $t("guest10_4") }}</span
              >
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/jiabin/custo23.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest11_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest11_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest11_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/219.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest12_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest12_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest12_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/220.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest13_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest13_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest3_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/221.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest14_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest14_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest14_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/222.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest15_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest15_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest15_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/223.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest16_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest16_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest16_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/224.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest17_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest17_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest17_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/225.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("guest18_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("guest18_2") }}<br />
              <span style="font-weight: bold">{{ $t("guest18_3") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="yjjb"
      ref="yjjb2"
      :class="{
        testhuiyi: true,
        testhuiyienter: yjjbShow2,
        testhuiyileave: !yjjbShow2,
      }"
    >
      <!-- <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
        "
      >
        <span class="title" style="width: 4rem">{{ $t("guests_title2") }}</span>
        <hr style="height: 0.3px; width: 50%" class="hr-dashed-fixed" />
      </div> -->

      <!--            <div class="text">
                PharmaX与您一样非常关注医药行业发展趋势与实时动态，我们与行业影响者、创新者，一同洞察行业政策、趋势、热点、痛点及新兴技术，分享优秀案例研究、新项目、新技术和独特见解，助力制药、医疗器械、生物技术、诊断、医疗机构和制药零售企业英才拥抱未来医药。
            </div>-->
      <div class="yjjb-bottom">
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/200.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest1_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest1_2") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest1_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/201.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest2_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest2_2") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest2_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/215.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest3_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest3_2") }}<br />
              <span style="font-weight: bold"
                >{{ $t("past_guest3_3") }}<br />{{ $t("past_guest3_4") }}</span
              >
            </div>
          </div>
        </div>
        <!-- <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/211.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest4_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest4_2") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest4_3") }}</span>
            </div>
          </div>
        </div> -->
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/212.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest5_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest5_2") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest5_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/216.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest6_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest6_2") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest6_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/210.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest7_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest7_2") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest7_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/217.jpg'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest8_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest8_2") }}<br />{{ $t("past_guest8_3") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest8_4") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/205.png'"
            />
          </div>
          <div style="margin-left: 20px; margin-top: 10px">
            <div class="yjjb-name">{{ $t("past_guest9_1") }}</div>
            <div class="yjjb-remark">
              {{ $t("past_guest9_2") }}<br />
              <span style="font-weight: bold">{{ $t("past_guest9_3") }}</span>
            </div>
          </div>
        </div>
        <div class="yjjb-item">
          <div>
            <!-- <img
              class="yjjb-tp"
              :src="fileServerUrl + 'assets/phamax/205.png'"
            /> -->
            <router-link to="/aggenda"><span class="moretext">MORE</span></router-link>
          </div>
        </div>


      </div>
    </div>

    <div
      class="rdht"
      style="display:none"
      ref="rdht"
      :class="{
        testhuiyi: true,
        testhuiyienter: rdhtShow,
        testhuiyileave: !rdhtShow,
      }"
    >
      <!-- <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
        "
      >
        <span class="title" style="width: 2rem">
          {{ $t("topic") }}
        </span>
        <hr style="height: 0.5px" class="hr-dashed-fixed" />
      </div> -->

    </div>

    <div
      class="cyxs"
      ref="cyxs"
      :class="{
        testhuiyi: true,
        testhuiyienter: cyxsShow,
        testhuiyileave: !cyxsShow,
      }"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
        "
      >
        <span class="title" style="width: 3rem">{{
          $t("form_of_participation")
        }}</span>
        <hr style="height: 0.5px; width: 80%" class="hr-dashed-fixed" />
      </div>
      <div class="text">
        {{ $t("type_text") }}
      </div>
      <div class="cyxs-bottom">
        <div class="cyxs-item xfxs-top">
          <img
            class="cyxs-tp"
            :src="fileServerUrl + 'assets/phamax/cyxs-01.jpg'"
          />
          <div class="cyxs-dbwz cyxs-db-bg1">{{ $t("type1") }}</div>
        </div>
        <div class="cyxs-item xfxs-top">
          <img
            class="cyxs-tp"
            :src="fileServerUrl + 'assets/phamax/cyxs-02.jpg'"
          />
          <div class="cyxs-dbwz cyxs-db-bg2">{{ $t("type2") }}</div>
        </div>
        <div class="cyxs-item xfxs-top">
          <img
            class="cyxs-tp"
            :src="fileServerUrl + 'assets/phamax/cyxs-03.jpg'"
          />
          <div class="cyxs-dbwz cyxs-db-bg1">{{ $t("type3") }}</div>
        </div>
        <div class="cyxs-item xfxs-top">
          <img
            class="cyxs-tp"
            :src="fileServerUrl + 'assets/phamax/cyxs-04.jpg'"
          />
          <div class="cyxs-dbwz cyxs-db-bg2">{{ $t("type4") }}</div>
        </div>
        <div class="cyxs-item xfxs-top">
          <img
            class="cyxs-tp"
            :src="fileServerUrl + 'assets/phamax/cyxs-05.jpg'"
          />
          <div class="cyxs-dbwz cyxs-db-bg1">{{ $t("type5") }}</div>
        </div>
        <div class="cyxs-item xfxs-top">
          <img
            class="cyxs-tp"
            :src="fileServerUrl + 'assets/phamax/cyxs-06.jpg'"
          />
          <div class="cyxs-dbwz cyxs-db-bg2">{{ $t("type6") }}</div>
        </div>
      </div>
    </div>

    <div class="xlzz">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
        "
      >
        <span class="title" style="width: 10em">{{
          $t("series_sponsorship")
        }}</span>
        <hr style="height: 0.5px; width: 70%" class="hr-dashed-fixed" />
      </div>
      <div class="xlzz-bottom">
        <!--                这里有bug,第一个跑马灯总是显示不全，所以在这加一个隐藏的-->
        <Pmd :images="images1" hidden=""></Pmd>
        <Pmd :images="images1" style="margin-top: 20px"></Pmd>
        <Pmd :images="images2" :oushu="1" style="margin-top: 20px"></Pmd>
        <Pmd :images="images3" style="margin-top: 20px"></Pmd>
        <Pmd :images="images4" :oushu="1" style="margin-top: 20px"></Pmd>

        <div class="xlzz-bottom-xh"></div>
        <div class="xlzz-bottom-xh2"></div>
      </div>
    </div>
    <!--        回到顶部-->
    <div class="hddb" v-show="showHddb">
      <i
        @click="counter1('#a1')"
        class="iconfont icon-fanhuidingbu11"
        style="color: rgb(31, 163, 209); font-size: 0.25rem"
      ></i>
    </div>

    <my-foot />
  </div>
</template>

<script>
import Pmd from "@/components/Pmd.vue";
import Gdt from "@/components/Gdt.vue";
import MyHeader from "@/components/MyHeader.vue";
import MyFoot from "@/components/MyFoot.vue";
import "animate.css";
import anime from "animejs/lib/anime.js";
export default {
  components: { Gdt, MyHeader, MyFoot, Pmd },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },

  data() {
    return {
      showHddb: false, //回到顶部
      active: 0,
      playPause: null,
      aboutCoreShow: false,
      yjjbShow: false,
      yjjbShow2: false,
      rdhtShow: false,
      cyxsShow: false,
      fileServerUrl: fileServerUrl,
      imgs: [
        { id: 1, img: fileServerUrl + "assets/phamax/hyld-01.jpg" },
        { id: 2, img: fileServerUrl + "assets/phamax/hyld-02.jpg" },
        { id: 3, img: fileServerUrl + "assets/phamax/hyld-03.jpg" },
        { id: 4, img: fileServerUrl + "assets/phamax/hyld-04.jpg" },
        { id: 5, img: fileServerUrl + "assets/phamax/hyld-05.jpg" },
        { id: 6, img: fileServerUrl + "assets/phamax/hyld-06.jpg" },
      ],
      // 一组跑马灯图片8个
      images1: [
        "assets/phamax/lb-1.jpg",
        "assets/phamax/lb-2.jpg",
        "assets/phamax/lb-3.jpg",
        "assets/phamax/lb-4.jpg",
        "assets/phamax/lb-5.jpg",
        "assets/phamax/lb-6.jpg",
      ],
      images2: [
        "assets/phamax/lb-8.jpg",
        "assets/phamax/lb-9.jpg",
        "assets/phamax/lb-10.jpg",
        "assets/phamax/lb-11.jpg",
        "assets/phamax/lb-20.png",
        "assets/phamax/lb-21.png",
      ],
      images3: [
        "assets/phamax/lb-22.png",
        "assets/phamax/lb-23.png",
        "assets/phamax/lb-24.png",
        "assets/phamax/lb-25.png",
        "assets/phamax/lb-27.png",
        "assets/phamax/lb-28.png",
        "assets/phamax/lb-35.png",
      ],
      images4: [
        "assets/phamax/lb-29.png",
        "assets/phamax/lb-30.png",
        "assets/phamax/lb-31.png",
        "assets/phamax/lb-32.png",
        "assets/phamax/lb-33.png",
        "assets/phamax/lb-34.png",
      ],
    };
  },
  methods: {
    counter1(item) {
      const returnEle = document.querySelector(item);
      if (!!returnEle) {
        returnEle.scrollIntoView(true);
      }
      document.querySelector(item).scrollIntoView(true);
      document.querySelector(item).scrollTop = 200;
      // this.scroll(document.getElementById(item).offsetTop - 15)
    }, //回到顶部

    handleScroll(e) {
      this.currentScroll = window.pageYOffset; //表示当前滚动的位置
      this.showHddb = this.currentScroll > 700;

      if (isMobile()) {
        this.aboutCoreShow = true;
        this.yjjbShow = true;
        this.yjjbShow2 = true;
        this.rdhtShow = true;
        this.cyxsShow = true;
      } else {
        this.currentScroll = window.pageYOffset; //表示当前滚动的位置
        // this.currentScroll = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop //表示当前滚动的位置
        this.aboutCoreShow =
          this.currentScroll >= this.$refs.huiyi.offsetTop - 850; //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.yjjbShow = this.currentScroll >= this.$refs.yjjb.offsetTop - 850; //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.yjjbShow2 = this.currentScroll >= this.$refs.yjjb2.offsetTop - 850; //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.rdhtShow = this.currentScroll >= this.$refs.rdht.offsetTop - 850; //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.cyxsShow = this.currentScroll >= this.$refs.cyxs.offsetTop - 850; //当前滚动位置到达testref的时候，显示div（100作为调整用）
      }
    },
    //回到顶部
    handleChange(val) {
      // console.log(val);
    },
    haveTitle(title) {
      return this.activeNames.indexOf(title) > -1;
    },
    clickTitle(title) {
      //存在删除，不存在添加
      if (this.haveTitle(title)) {
        let newArray = [];
        this.activeNames.forEach((item) => {
          if (item != title) {
            newArray.push(item);
          }
        });
        this.activeNames = newArray;
      } else {
        this.activeNames.push(title);
      }
    },
  },
  created() {
    if (isMobile()) {
      this.aboutCoreShow = true;
      this.yjjbShow = true;
      this.yjjbShow2 = true;
      this.rdhtShow = true;
      this.cyxsShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/simpleAnimation.scss";
@import "@/assets/css/common.scss";

.template {
  scroll-behavior: smooth;
}

* {
  overflow: hidden;
  //font-family: weiruan;
}
.font-mini {
  font-size: 12px;
}

//通用类

.ty-display {
  display: flex;
}

.ty-display-col {
  display: flex;
  flex-direction: column;
}

.ty-font {
  font-size: 0.1rem;
}

.ty-wenzi {
  font-size: 0.1rem;
  text-align: justify;
  color: #575757;
}

.ty-shuhei {
  font-family: "阿里妈妈数黑体 Bold";
}

.ty-lineheight {
  padding-top: 5px;
  font-size: 0.5rem;
}

.ty-color {
  color: rgb(0, 239, 252);
}

.hr-dashed-fixed {
  width: 90%;
  border: 0;
  padding-top: 0.4px;
  background: repeating-linear-gradient(
    to right,
    rgb(31, 163, 209) 8px,
    rgb(31, 163, 209) 12px,
    transparent 12px,
    transparent 14px
  );
}
.swiper_area {
  padding-top: 50px;
  width: auto;
  ::v-deep .el-carousel__arrow {
    width: 25px;
    height: 25px;
    background-color: #4f4f4fcf;
  }
  img {
    object-fit: cover;
    height: 150px;
    width: 100%;
    align-content: center;
  }
}
div {
  font-family: weiruan; //使用字体
}

.one {
  height: 115vh;
  width: 100%;
  margin-top: 14px;
  background-image: url("https://hyhzpharmax-1316759422.cos.ap-shanghai.myqcloud.com/assets/bg(1).jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.one-font {
  margin-left: 10%;
  margin-top: 5%;
  //border: 1px solid red;
  color: white;
}

.time-site {
  margin-top: 30px;
  font-size: 0.18rem;
  //border:1px solid fuchsia;
}

.time-site-item1 {
  display: flex;
  justify-content: left;
  align-items: center;
  //border:1px solid rebeccapurple;
}
.time-site-item2 {
  margin-top: 10px;
  display: flex;
  justify-content: left;
  align-items: center;
  //border:1px solid rebeccapurple;
}
.once-join {
  margin-top: 10px;
  font-size: 0.13rem;
  background-color: rgb(0, 239, 252);
  border: 0;
  padding: 2px 10px;
  border-radius: 9px;
  transition: all 0.5s;
  &:hover {
    padding: 2px 15px;
  }
}
.two {
  margin-top: 30px;
  margin-left: 90px;
  width: 550px;
}
.two1 font {
  font-size: 22px;
  font-weight: bold;
  //color: #424cf9;
}

.two1 {
  width: 20%;
  height: 50px;
  margin: auto;
  //border-left: 1px solid #424cf9;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
}

.two2 {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
  //border: 1px solid red;
}

.two2 span {
  color: rgb(31, 163, 209);
}

.hyld {
  width: 75%;
  // height: 250px;
  //border:.1px solid red;
  margin-left: 12.5%;
  display: flex;
  margin-bottom: 20px;
}
.hyld-item1 {
  width: 100%;
  // height: 245px;
  //border: .1px solid blue;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hyld-item2 {
  height: 250px;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 90%;
    object-fit: cover;
    width: 65%;
  }
}

.hyld-item-logo {
  width: 120px;
  height: 45px;
  //border: 1px solid springgreen;
  display: flex;
  align-items: center;
}
.hyld-item-logo img {
  width: 100%;
  height: 50%;
}
.hyld-item-wenzi {
  width: 100%;
  // height: 180px;
  line-height: 12px;
  //border: .1px solid darkseagreen;
}

.conference-highlights {
  width: 75%;
  height: auto;
  //border:1px solid red;
  margin-left: 12.5%;
}

.title {
  font-size: 0.2rem;
  color: rgb(31, 163, 209);

  font-family: "阿里妈妈数黑体 Bold" !important;
}
.title.num {
  color: #525252;
  font-size: 0.14rem;
}
.title2 {
  font-size: 0.16rem;
  color: rgb(31, 163, 209);
  font-family: "阿里妈妈数黑体 Bold" !important;
}
.titleBig {
  font-size: 0.2rem;
  color: #525252;
}
.titSub {
  font-size: 0.12rem;
  color: #525252;
  font-weight: bold;
  font-family: "阿里妈妈数黑体 Bold" !important;
  padding-bottom:0.05rem;
}
.textSubCont {
  font-size: 0.1rem;
  font-family: PuHuiTi;
  line-height: 12px;
  color: #525252;
  background-color: #f3f3f3;
  padding:0rem 0.1rem;
  margin-bottom:0.15rem;
  border:1px dashed rgba(31, 163, 209,0.3);
  display:flex;
  align-items: center;
}


.text {
  font-size: 0.1rem;
  font-family: PuHuiTi;
  line-height: 12px;
  color: #525252;
}
.textCont {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.textCont01 {
  color: #525252;
  background-color: #f3f3f3;
  padding:0.1rem 0.1rem;
  margin:0.05rem 0;
  border:1px dashed rgba(31, 163, 209,0.3);
  overflow: hidden;
}
.moretext{
  font-size:0.18rem;
  font-weight:bold;
  color:#525252;
  margin-top:0.56rem;
  display:block;
}
.textCont01 .tit{
  font-size: 0.12rem;
  line-height: 14px;
  color: #525252;
  font-weight:bold;
  padding-bottom: 0.05rem;
}
.textCont01 .cont{
  font-size: 0.1rem;
  color: #525252;
}
.textCont01 p{
  margin:2px 0px;
}

.tellhot{
  display: flex;
  align-items: center;
  padding:3px 0;
}
.tellhot img{
  width:0.15rem;
  padding:0px;
  margin:0px;
}

.yjjb {
  width: 75%;
  height: auto;
  //border:1px solid red;
  margin-left: 12.5%;
  margin-top: 20px;
}

.yjjb-bottom {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  // margin-top: 30px;
}
.yjjb-item {
  width: 29%;
  margin-left: 4%;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  div:nth-child(1) {
    overflow-x: visible;
  }
}
.yjjb-wzbf {
  display: flex;
}
.yjjb-name {
  color: rgb(31, 163, 209);
  font-weight: bold;
  font-family: PuHuiTi;
  text-align: justify;
  font-size: 0.12rem;
  margin-bottom: 3px;
}
.yjjb-remark {
  color: #4f4f4f;
  font-size: 0.1rem;
  line-height: 12px;
  font-family: PuHuiTi;
}
.yjjb-tp {
  width: 60px;
  height: 60px;
  transition: all 1s;
  transform: scale(1);
}

.yjjb-tp:hover {
  transform: scale(1.05);
  transition: all 1s;
}
.rdht {
  width: 75%;
  height: auto;
  //border:0.1px solid red;
  margin-left: 12.5%;
  margin-top: 5%;
}
.rdht-bottom {
  display: flex;
  flex-wrap: wrap;
  height: 250px;
  justify-content: space-between;
  //border: 0.1px solid red;
}
.rdht-item {
  width: 33%;
  position: relative;
}

.rd-font {
  color: white;
  font-size: 0.16rem;
  font-family: PuHuiTi;
  font-weight: bold;
  position: absolute;
  letter-spacing: 0.01rem;
  //line-height: 0.28rem;
  vertical-align: middle;
  //border: 1px solid red;
  top: 10%;
  left: 8%;
}

.rdht-tp {
  width: 180px;
  height: 65px;
  border-radius: 7px;
  margin-bottom: 10px;
}

.cyxs {
  width: 75%;
  height: auto;
  //border:1px solid red;
  margin-left: 12.5%;
  margin-top: 5%;
}
.cyxs .text {
  position: relative;
  z-index: 1;
}

.cyxs-bottom {
  font-size: 0.1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 30px;
  margin-top: -10px;
}
.cyxs-item {
  width: 15%;
  position: relative;
}
.cyxs-tp {
  width: 100%;
  height: 120px;
  border-radius: 7px;
  margin-bottom: 10px;
  object-fit: cover;
}
.cyxs-dbwz {
  color: white;
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;
  border-radius: 0 0 7px 7px;
  z-index: 2;
}
.cyxs-db-bg1 {
  background-color: rgb(31, 163, 209);
}
.cyxs-db-bg2 {
  background-color: rgb(31, 163, 209);
}

.xlzz {
  width: 75%;
  height: auto;
  //border:1px solid red;
  margin-left: 12.5%;
  margin-top: 5%;
  margin-bottom: 5%;
}

.xlzz-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.xlzz-bottom-xh {
  width: 20%;
  height: 100%;
  position: absolute;
  right: 0;
  z-index: 2;
  background-image: linear-gradient(
    to left,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.08)
  );
}
.xlzz-bottom-xh2 {
  width: 25%;
  height: 100%;
  position: absolute;
  z-index: 2;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.08)
  );
}
</style>
